import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import PageHeader from '../components/PageHeader';
import { buildApiUrl } from '../utils/api';

import FirstImage from '../static/assets/images/C92C140F-970B-4704-B73B-51A17863B379_1_201_a.jpeg';
import SecondImage from '../static/assets/images/C502BC34-CE1A-4536-BF7A-CA0F20A76BC3_1_105_c.jpeg';
import ThirdImage from '../static/assets/images/IMG_8546.jpg';
import FourthImage from '../static/assets/images/IMG_8916-2.jpg';
import FifthImage from '../static/assets/images/C9EBF066-E6E1-45B4-87F7-A53C628727D3_1_201_a.jpeg';
import SixthImage from '../static/assets/images/IMG_6516.jpg';

import GIF from '../static/assets/images/Brooklyn_Nine_Nine_Jake_Wins_a_Bet_and_Plans_a_Terrible_Date_With_Amy.gif';
import IcecreamSticker from '../static/assets/images/image copy.png';
import noodleSticker from '../static/assets/images/image.png';


import '../static/styles/LongMessage.css';

const headerContent = {
    header: 'Hey Saakshi,',
    emoji: '❤️',
    subheading: 'A small corner of the internet, made just for you',
};

// Replace these paragraphs with your long message.
const opheliaImages = [
    {
        type: 'image',
        src: FirstImage
    },
    {
        type: 'image',
        src: SecondImage
    },
    {
        type: 'image',
        src: ThirdImage
    },
    {
      type: 'image',
      src: FourthImage,
    },
    {
      type: 'image',
      src: FifthImage,
    },
    {
      type: 'image',
      src: SixthImage,
    }
];

const messageParagraphs = [
  {
    type: "text",
    lines: ["Hmmmm… you are probably wondering what is this 👀"]
  },
  {
    type: "text",
    lines: [
      "This is a little gift from my side for always being there for me and for always being my friend oops sorry my best friend 😌"
    ]
  },
  {
    type: "text",
    lines: [
      "You gave me the most expensive gift anyone has ever given me. And you know me gifting me is hard and I rarely like things easily. But somehow you cracked the formula.",
      "It was honestly dumb of me that I did not thank you properly for that. I guess I am just bad at showing emotions sometimes 🫠"
    ]
  },
  {
    type: "text",
    lines: [
      "So this is my small return gift.",
      "And before you overthink this gift is purely from your best friend nothing else attached.",
      "I hope you like it 🤍"
    ]
  },
  {
    type: "text",
    lines: [
      "Okay now there is something more I need to say and ask you.",
      "And I want you to know this clearly that I am not saying any of this because of anyone else.",
      "No one suggested this. No one pushed me.",
      "These words are coming only from my heart and my feelings for you 🤍"
    ]
  },
  {
    type: "text",
    lines: [
      "You might be thinking why I am doing this here instead of in person on a call or over a text.",
      "I usually prefer saying things like this face to face but I was scared it might mess up our trip and right now we are 2900 miles apart."
    ]
  },
  {
    type: "text",
    lines: [
      "I wanted something more creative.",
      "I mean if I am confessing something to SAAKSHI I had to put in some serious effort 😌",
      "Something that lasts longer than a message bubble 💬",
      "Something you can read slowly at your own pace.",
      "No pressure. No interruptions. Just you and these words."
    ]
  },
  {
    type: "text",
    lines: [
      "Also I am a certified chomu 😬",
      "And you already know my communication skills 😑",
      "So this was my way of saying things clearly without messing them up.",
      "FYI I haven't used ChatGPT for this 😭",
      "Plus okay I am a techie so I had to flex my CS skills a little 😌💻"
    ]
  },
  {
    type: "text",
    lines: [
      "There is something I have never fully explained before.",
      "When I once said I do not want to date right now I will start dating in January it was not because I did not feel anything for anyone.",
      "It was because I wanted to work on myself to become someone who could truly stand beside a person like you.",
      "I never wanted you to feel like you were settling."
    ]
  },
  {
    type: "text",
    lines: [
      "I was afraid.",
      "Afraid of not being in good shape.",
      "Afraid of not being financially stable.",
      "Afraid of not being good looking.",
      "And okay the face thing is non negotiable I have accepted my fate there 😌"
    ]
  },
  {
    type: "text",
    lines: [
      "I also owe you honesty about something else.",
      "I lied about the first time in the US reason.",
      "The real reason was that you completely overwhelmed me.",
      "You were the most beautiful and hottest person I had ever been with and my brain just stopped working 🫠",
      "I genuinely could not process it.",
      "I am really sorry if that moment was uncomfortable or traumatizing for you. I never meant to hurt you in any way."
    ]
  },
  {
    type: "text",
    lines: [
      "Through everything you have always had this quiet power over me.",
      "Being with you has only made my life better.",
      "You know so much about me and that is special because I have never felt this comfortable opening up to anyone before.",
      "Having you in my life means I know there is at least one person who genuinely cares about my happiness and growth 🤍"
    ]
  },
  {
    type: "text",
    lines: [
      "Do you know about the Marigold Theory",
      "You can read it here: https://medium.com/@yashimycutie/the-marigold-theory-3d354f77a1b0",
      "YOU are my MARIGOLD 🌼"
    ]
  },
  {
    type: "text",
    lines: [
      "Our friendship has seen so many ups and downs and yet it is still unshakable.",
      "We have traveled explored and shared so much. It reminds me of what Taylor Swift wrote",
    ]
  },
  { type: 'media', items: opheliaImages },
  {
    type: "text",
    lines: [
      "And when I think of those words I do not see just one place or one moment.",
      "I see us across everything we have shared so far."
    ]
  },
  {
    type: "text",
    lines: [
      "I know your priorities and your goals and I never wanted to interfere with them.",
      "The least and also the most I ever wanted was for us to stay what we already are",
      "a healthy honest friendship that feels safe 🤍"
    ]
  },
  {
    type: "text",
    lines: [
      "If you are ever open to being more than friends I am open too.",
      "But only if it feels right for you.",
      "No expectations.",
      "No pressure.",
      "Ever."
    ]
  },
  {
    type: "text",
    lines: [
      "I have said before that I am not comfortable with long distance relationships.",
      "But honestly if it is you I think I could make it work."
    ]
  },
  {
    type: "text",
    lines: [
      "No matter what happens after this I need you to know one thing.",
      "Whatever your answer is you will never lose your global best friend 🌍❤️"
    ]
  },
  {
    type: "text",
    lines: [
      "I am still in the middle of my transformation.",
      "Right now all I can ask you for is belief.",
      "Believe that I am becoming the person I want to be.",
      "And one day that person will make you proud 🤍"
    ]
  },
  {
    type: "text",
    lines: [
      "This message is already long 😅",
      "And it would get even longer if I kept talking about beautiful things about you.",
      "But whenever I think of beautiful things I think of what Benson Boone said",
    ]
  },
  {
    type: "lyrics",
    lines: [
      "And I thank God every day",
      "For the girl He sent my way",
      "But I know the things He gives me",
      "He can take away",
      "And I hold you every night",
      "And that's a feelin' I wanna get used to",
      "But there's no man as terrified",
      "As the man who stands to lose you",
      "Oh, I hope I don't lose you"
    ]
  },
  {
    type: "text",
    lines: [
      "SO HERE I GO....",
    ]
  }
];
  

const followUpOptions = ['Keep it, Feb 14th', 'I have Lightning Lane Pass'];
const valentineGifUrl = GIF;
const isUnlocked = true;

export default function LongMessage() {
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [dialogStep, setDialogStep] = useState('options');
    const [selectedOption, setSelectedOption] = useState('');
    const [isNoConfirmVisible, setIsNoConfirmVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isNoSubmitting, setIsNoSubmitting] = useState(false);
    const [statusDialog, setStatusDialog] = useState({
        isOpen: false,
        type: 'success',
        message: '',
    });

    const openFollowUp = () => {
        setSelectedOption('');
        setDialogStep('options');
        setIsDialogVisible(true);
    };

    const handleNo = () => {
        setIsNoConfirmVisible(true);
    };

    const handleNoConfirm = async () => {
        setIsNoSubmitting(true);

        try {
            const response = await fetch(buildApiUrl('/long-message/confirm'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    answer: 'no',
                    option: null,
                }),
            });

            if (!response.ok) {
                const message = await response.json().catch(() => ({}));
                throw new Error(message?.detail || message?.message || 'Failed to save selection.');
            }

            setIsNoConfirmVisible(false);
            setIsDialogVisible(false);
            setSelectedOption('');
            setDialogStep('options');
            openStatusDialog(
                'success',
                'Your response has successfully recorded!'
            );
        } catch (error) {
            openStatusDialog(
                'error',
                'If something failed, please send a photo with your eyes staring at me. So I know I have messed this up.'
            );
        } finally {
            setIsNoSubmitting(false);
        }
    };

    const handleNoCancel = () => {
        setIsNoConfirmVisible(false);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setDialogStep('confirm');
    };

    const handleDialogClose = () => {
        setIsDialogVisible(false);
        setDialogStep('options');
        setSelectedOption('');
    };

    const openStatusDialog = (type, message) => {
        setStatusDialog({
            isOpen: true,
            type,
            message,
        });
    };

    const closeStatusDialog = () => {
        setStatusDialog((prev) => ({
            ...prev,
            isOpen: false,
        }));
    };

    const handleConfirm = async () => {
        if (!selectedOption) {
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(buildApiUrl('/long-message/confirm'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    answer: 'yes',
                    option: selectedOption,
                }),
            });

            if (!response.ok) {
                const message = await response.json().catch(() => ({}));
                throw new Error(message?.detail || message?.message || 'Failed to save selection.');
            }

            handleDialogClose();
            openStatusDialog(
                'success',
                'Your response has successfully recorded I will call you to discuss this further.'
            );
        } catch (error) {
            openStatusDialog(
                'error',
                'If something failed, please send a photo with your eyes staring at me. So I know I have messed this up.'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="long-message">
            <div className="long-message__edge-hearts" aria-hidden="true" />
            <div className="long-message__doodle long-message__doodle--one" aria-hidden="true" />
            <div className="long-message__doodle long-message__doodle--two" aria-hidden="true" />
            <div className="long-message__doodle long-message__doodle--three" aria-hidden="true" />
            <PageHeader data={headerContent} />
            {isUnlocked ? (
                <>
                    <section className="long-message__content">
                        {messageParagraphs.map((paragraph, index) => {
                            if (paragraph.type === 'media') {
                                return (
                                    <div key={index} className="long-message__media">
                                        {paragraph.items.map((item) => (
                                            <figure key={item.src} className="long-message__media-item">
                                                <img src={item.src} alt={item.alt} loading="lazy" />
                                                <figcaption>{item.caption}</figcaption>
                                            </figure>
                                        ))}
                                    </div>
                                );
                            }

                            const lines = paragraph.lines.map((line, lineIndex) => (
                                <React.Fragment key={lineIndex}>
                                    {line}
                                    {lineIndex < paragraph.lines.length - 1 ? <br /> : null}
                                </React.Fragment>
                            ));

                            return paragraph.type === 'lyrics' ? (
                                <blockquote key={index} className="long-message__lyrics">
                                    <p>{lines}</p>
                                </blockquote>
                            ) : (
                                <p key={index}>{lines}</p>
                            );
                        })}
                    </section>
                    <section className="long-message__prompt">
                        <h2>SAAKSHI will you be my Valentine? 💖</h2>
                        <img
                            className="long-message__prompt-gif"
                            src={valentineGifUrl}
                            alt="Animated hearts floating"
                            loading="lazy"
                        />
                        <p>Would you go on a Valentines Day virtual date with me</p>
                        <p>Just two people who already mean a lot to each other sharing a moment and seeing where it goes 🌙✨</p>
                        <div className="long-message__actions">
                            <Button label="Yes, let's try this together" rounded onClick={openFollowUp} />
                            <Button label="No" rounded outlined onClick={handleNo} />
                        </div>
                        <div className="long-message__prompt-followup">
                            <p>If your answer is <b>No</b></p>
                            <p>Nothing changes I stay with the same respect the same care and the same gratitude for you being in my life.</p>
                            <p>And if your answer is <b>Yes</b></p>
                            <p>Well you get a date on top of a best friend 😉✨</p>
                        </div>
                    </section>
                </>
            ) : (
                <section className="long-message__locked">
                    <h2>Hold tight 💝</h2>
                    <p>This message unlocks once the gift is received.</p>
                </section>
            )}
            <Dialog
                header={dialogStep === 'options' ? 'Yayyy!' : 'Confirm selection'}
                visible={isDialogVisible}
                onHide={handleDialogClose}
                className="long-message__dialog"
            >
                {dialogStep === 'options' ? (
                    <div className="long-message__dialog-body">
                        <p>You can get a early virtual date before the actual valentine's date, if you have a LIGTHNING PASS! </p>
                        <div className="long-message__dialog-actions">
                            {followUpOptions.map((option) => (
                                <Button
                                    key={option}
                                    label={option}
                                    rounded
                                    onClick={() => handleOptionSelect(option)}
                                />
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="long-message__dialog-body">
                        <p>
                            You selected <strong>Yes, let's try this together</strong> and <strong>{selectedOption}</strong>.
                        </p>
                        <p>Would you like to confirm?</p>
                        <div className="long-message__dialog-actions">
                            <Button
                                label="Back"
                                rounded
                                outlined
                                onClick={() => setDialogStep('options')}
                            />
                            <Button label="Confirm" rounded onClick={handleConfirm} disabled={isSubmitting} />
                        </div>
                    </div>
                )}
            </Dialog>
            <Dialog
                header="Confirm your selection"
                visible={isNoConfirmVisible}
                onHide={handleNoCancel}
                className="long-message__dialog"
            >
                <div className="long-message__dialog-stickers" aria-hidden="true">
                    <img className="long-message__dialog-sticker" src={IcecreamSticker} alt="" loading="lazy" />
                    <img className="long-message__dialog-sticker" src={noodleSticker} alt="" loading="lazy" />
                </div>
                <div className="long-message__dialog-body">
                    <p>Are you sure you want to choose No? You may miss visuals like this 🥹</p>
                    <div className="long-message__dialog-actions">
                        <Button label="Cancel" rounded outlined onClick={handleNoCancel} />
                        <Button label="Yes, confirm" rounded onClick={handleNoConfirm} disabled={isNoSubmitting} />
                    </div>
                </div>
            </Dialog>
            <Dialog
                header={statusDialog.type === 'success' ? 'Message received 💌' : 'Uh-oh 💔'}
                visible={statusDialog.isOpen}
                onHide={closeStatusDialog}
                className="long-message__dialog long-message__status-dialog"
            >
                <div className="long-message__status-body">
                    <p>{statusDialog.message}</p>
                    <div className="long-message__dialog-actions">
                        <Button label="Close" rounded onClick={closeStatusDialog} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
